(() => {
  'use strict';
  const guide = document.querySelector('[data-nzc-brand-guide]');
  const selector = document.getElementById('nzc-variant');
  if (!guide || !selector) return;
  const labels = JSON.parse(document.getElementById('NzcBrandSizeLabels')?.textContent || '{}');
  const selectedText = guide.querySelector('[data-nzc-size-current]');
  const status = guide.querySelector('[data-nzc-chart-match]');
  const warning = document.querySelector('[data-nzc-size-warning]');
  const headers = Array.from(guide.querySelectorAll('[data-size-column]')).map(e => e.dataset.sizeColumn);
  const rows = Array.from(guide.querySelectorAll('tbody tr'));
  const normalize = value => String(value).trim().toUpperCase().replace(/\s+/g, '').replace(/JUNIOR|YOUTHS?/g, '').replace(/^US|^UK/, '').replace(/C$/, 'K').replace(/Y$/, '');
  const refresh = () => {
    const variantLabel = selector.selectedOptions[0]?.textContent.trim() || '';
    if (selectedText) {
      const value = variantLabel === 'Default Title' ? guide.dataset.productTitle || '' : variantLabel;
      selectedText.textContent = (labels.selected || '').replace('__option__', value);
    }
    if (!status || guide.dataset.category !== 'shoes') return;
    rows.forEach(row => {row.classList.remove('is-selected');row.removeAttribute('aria-current');});
    const units = variantLabel.match(/\b(UK|US|EU)\s*[-:]?\s*(\d+(?:\.\d+)?(?:K|C|Y)?)/i);
    if (!units) {
      status.textContent = labels.unverified || '';
      status.classList.add('is-uncovered');
      if (warning) { warning.hidden = false; warning.textContent = labels.unverified || ''; }
      return;
    }
    const system = units[1].toLowerCase();
    const column = headers.findIndex(header => header === system || (system === 'us' && header.startsWith('us_')));
    const found = column < 0 ? undefined : rows.find(row => normalize(row.cells[column]?.textContent || '') === normalize(units[2]));
    status.classList.toggle('is-uncovered', !found);
    if (warning) { warning.hidden = !!found; warning.textContent = found ? '' : (labels.not_covered || '').replace('__size__', units[1].toUpperCase() + ' ' + units[2].toUpperCase()); }
    if (found) {
      found.classList.add('is-selected'); found.setAttribute('aria-current', 'true');
      status.textContent = (labels.matched || '').replace('__size__', units[1].toUpperCase() + ' ' + units[2].toUpperCase());
    } else {
      status.textContent = (labels.not_covered || '').replace('__size__', units[1].toUpperCase() + ' ' + units[2].toUpperCase());
    }
  };
  document.addEventListener('change', event => {
    if (event.target.matches('#nzc-variant,[data-variant-radio]')) queueMicrotask(refresh);
  });
  document.addEventListener('variant:change', refresh);
  refresh();
})();
